import {
  ExamCenterLocationDetails,
  ExamLocationDetailsPageHeader,
} from '@exam-center/exam-center-location-details';

export default function ExamCenterLocationDetailsPage() {
  return (
    <>
      <ExamLocationDetailsPageHeader />
      <ExamCenterLocationDetails />
    </>
  );
}
